import type {
  FeatureFlagNamesEnum,
  GetFeatureFlagsQuery,
} from "src/graphql/generated/types";

/**
 * The flags active for the account displayed: the global ones plus that
 * account's own. With no account displayed, the flags of every account count,
 * so a page outside any account keeps seeing what one of them has.
 */
export function getActivatedFeatureFlags(
  featureFlags: GetFeatureFlagsQuery["featureFlags"],
  { accountId }: { accountId: string | undefined },
): ReadonlySet<FeatureFlagNamesEnum> {
  const accounts = featureFlags.accounts ?? [];
  const specificFeatures =
    accountId === undefined
      ? accounts.flatMap((account) => account.specificFeatures)
      : (accounts.find((account) => account.accountId === accountId)
          ?.specificFeatures ?? []);

  return new Set([...(featureFlags.globalFeatures ?? []), ...specificFeatures]);
}
